import { render, staticRenderFns } from "./AdminProductSearch.vue?vue&type=template&id=005caa19"
import script from "./AdminProductSearch.vue?vue&type=script&lang=js"
export * from "./AdminProductSearch.vue?vue&type=script&lang=js"
import style0 from "./AdminProductSearch.vue?vue&type=style&index=0&id=005caa19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports